// Builds the order payload for the Stripe V2 pilot's completion page.
//
// Identity (cart + email) comes from the PaymentIntent's OWN metadata --
// stamped server-side at creation -- never from sessionStorage: a stale
// sessionStorage entry once replayed another customer's cart against a live
// charge (2026-09-03). sessionStorage only contributes contact/shipping
// details, and only when its stored cart matches the cart the money was
// actually taken for; on a mismatch the order is STILL created (blank
// contact fields, backfillable from the charge) rather than silently
// skipped -- a paid-but-no-order state is the worst outcome.
//
// Returns null only when the intent carries no cart identity at all (e.g.
// the intent fetch failed); the caller must then surface a loud
// payment-succeeded-but-no-order message, never an unqualified success.
export default function buildOrderPayload({
  intentData, paymentIntentId, storedCartId, storedEmail, storedCustomerDataJson,
}) {
  const cartId = intentData?.metadata?.cart_id;
  // The stored email is identity too: it may only stand in for a blank
  // cart_email when it belongs to THIS cart -- otherwise a stale entry would
  // attach a different customer's email to a correctly-fulfilled order.
  const identityMatches = String(storedCartId) === String(cartId);
  const email = intentData?.metadata?.cart_email || (identityMatches ? storedEmail : undefined);
  if (!cartId || !email) return null;

  let customerData = {};
  if (storedCustomerDataJson && identityMatches) {
    try {
      customerData = JSON.parse(storedCustomerDataJson) || {};
    } catch (e) {
      customerData = {};
    }
  }
  const shippingAddress = customerData.shippingAddress || {};
  const billingAddress = (intentData?.payment_method?.billing_details || {}).address || {};

  return {
    email,
    first_name: customerData.firstName || '',
    last_name: customerData.lastName || '',
    phone: customerData.phone || '',
    cart_id: cartId,
    payment_method: 'stripe_test',
    paypal_order: JSON.stringify({ paymentIntent: paymentIntentId, test_checkout: true }),
    paid_with_paypal: true,
    address: billingAddress.line1 || '',
    address2: billingAddress.line2 || '',
    city: billingAddress.city || '',
    state: billingAddress.state || '',
    zip_code: billingAddress.postal_code || '',
    shipping_address: shippingAddress.address1 || '',
    shipping_address2: shippingAddress.address2 || '',
    shipping_city: shippingAddress.city || '',
    shipping_state: shippingAddress.state || '',
    shipping_zip: shippingAddress.zip || '',
  };
}
